import { useMutation } from "@tanstack/react-query";
import Auth from "src/Auth";
import * as Sentry from "@sentry/react";

type ProtoProjectResponse = {
  id: string;
  shortCode: string;
  title: string;
  storyguide: string;
  genre: string;
  documents: Array<{
    id: string;
    title: string | null;
    text: string;
    order_index: number;
  }>;
  used: boolean;
  createdAt: string;
  expiresAt: string;
};

type ConvertResponse = {
  success: boolean;
  projectId?: string;
  error?: string;
};

export const useGetProtoProject = () =>
  useMutation({
    mutationKey: ["get-proto-project-by-shortcode"],
    mutationFn: async (shortCode: string) => {
      return (await Auth.fetchWithIdToken(`/api/proto-projects/${shortCode}`)) as ProtoProjectResponse;
    },
    onError: (error) => {
      Sentry.captureException(error);
    },
  });

export const useConvertProtoProject = () =>
  useMutation({
    mutationKey: ["convert-proto-project"],
    mutationFn: async (shortCode: string) => {
      return (await Auth.fetchWithIdToken("/api/ai/proto-projects/convert", {
        shortCode: shortCode,
      })) as ConvertResponse;
    },
    onError: (error) => {
      Sentry.captureException(error);
    },
  });
